module.exports = __webpack_public_path__ + "img/Mid-AutumnFestival.54df8be9.jpg";